import React, {useState} from "react";
import IndicadorEstado from "../../../../components/IndicadorState";
import Tooltip from "@mui/material/Tooltip";
import {modalSideService} from "../../../../services/modalSideService";
import {Colors} from "../../../../assets/colors/Colors";
import InputForm from "../../../../components/ComponentesFormularios/InputForm";
import {convertToString} from "../../../../util/functions";


const FormUsuariosRolesDetail = ({properties}) => {

  let { idRol, nmRol, data } = properties;
  const [stateFilter, setStateFilter] = useState("");

  const handleChangeInput = (value) => {
    setStateFilter(value);
  }

  return(

    <div>

      <div className="mb-3 d-flex align-items-center justify-content-end">

        <Tooltip title="Cerrar" aria-label="cerrar">
          <a onClick={() => modalSideService.clear()} className="icon-container-actions d-flex mr-0">
            <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
            <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times fa-2x"/>
          </a>
        </Tooltip>
      </div>

      <p className="mb-0 text-justify">Aqui podrás visualizar los menus asociados al rol de <strong>{nmRol} ({idRol})</strong></p>

      <InputForm identificador={`filterProductos`} label={``} value={stateFilter}
                 placeholder="Buscar..." type="text" className={`px-0 col-12`} handleChange={({name, value}) => handleChangeInput(value)}
      />

      {
        data?.filter(x =>
          (convertToString(x.nombre)?.toUpperCase()?.includes(convertToString(stateFilter)?.toUpperCase()) ||
            convertToString(x.descripcion)?.toUpperCase()?.includes(convertToString(stateFilter)?.toUpperCase())))?.map((item, index) => (
          <div key={`mn${item.id}${index}`} className="card cardDetail boxShadow flex-row row p-2 mx-1 justify-content-between align-items-center marginTop20" style={{border: "2px dashed gray"}}>
            <section className="p-2">
              <strong className="font-sm">Nombre</strong>
              <div className="font-sm">{item.nombre}</div>
            </section>
            <section className="p-2">
              <strong className="font-sm">Descripción</strong>
              <div className="font-sm">{item.descripcion}</div>
            </section>
            <section className="p-2">
              <strong className="font-sm">Estado</strong>
              <div className="font-sm d-flex align-items-center">
                <IndicadorEstado state={convertToString(item.estado) === '1'} width={10} height={10}/>
                <span className="mx-1">{convertToString(item.estado) === '1' ? 'Activo' : 'Inactivo'}</span>
              </div>
            </section>
          </div>
        ))
      }

    </div>

  )


}

export default FormUsuariosRolesDetail;
